/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const BankStatement: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M21 0H3C2.73478 0 2.48043 0.105357 2.29289 0.292893C2.10536 0.48043 2 0.734784 2 1V23C2 23.2652 2.10536 23.5196 2.29289 23.7071C2.48043 23.8946 2.73478 24 3 24H21C21.2652 24 21.5196 23.8946 21.7071 23.7071C21.8946 23.5196 22 23.2652 22 23V1C22 0.734784 21.8946 0.48043 21.7071 0.292893C21.5196 0.105357 21.2652 0 21 0V0ZM13 20H5V18H13V20ZM19 16H5V14H19V16ZM19 9H17V12H15V9H13V12H11V9H9V12H7V9H5V7L12 4L19 7V9Z'
      fill='currentColor'
    />
  </React.Fragment>
)
